import { render, staticRenderFns } from "./SalesStatus.vue?vue&type=template&id=2dc1447a&scoped=true"
import script from "./SalesStatus.vue?vue&type=script&lang=js"
export * from "./SalesStatus.vue?vue&type=script&lang=js"
import style0 from "./SalesStatus.vue?vue&type=style&index=0&id=2dc1447a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1447a",
  null
  
)

export default component.exports